import React from 'react';
import PropTypes from 'prop-types';
import Text from './Text';

class Element extends React.Component {
  render() {
    const { elementClass, label, unit, children } = this.props;
    return (
      <div className={elementClass ? elementClass : ""}>
          <Text className="Text-question--bold"> {label} </Text>
          {' '}
          <Text className="Text-question--unit"> {unit} </Text> 
        {children}
      </div>
    );
  }
};

Element.propTypes = {
  label: PropTypes.string.isRequired,
  unit: PropTypes.string,
  elementClass: PropTypes.string,
  children: PropTypes.element.isRequired,
};

export default Element;
